import { useContext } from "react";
import { I18nContext } from "../../i18n/useI18n";
import PrincipalBanner from "../../contents/PrincipalBanner";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";

const educationContent = "pages.public-engagement.education";

const Page = () => {
  const { t } = useContext(I18nContext);
  return (
    <main className="mx-auto my-0 max-w-7xl">
      <PrincipalBanner
       
        classNames={twMerge(clsx("min-h-[200px] md:min-h-[400px]"))}
      >
        <img
          className="absolute w-full min-h-full bottom-[-550%] object-cover"
          src="https://static.igem.wiki/teams/5058/home-page-igem-2024.png"
          alt="bannner education"
        />
        <h1 className="invisible">{t(`${educationContent}.title`)}</h1>
      </PrincipalBanner>
      <img
        className="w-full min-h-full object-cover"
        src="https://static.igem.wiki/teams/5058/imgs/frase-paulo-freire.svg"
        alt="banner education"
      />
      {/* <img
        className="w-full min-h-full object-cover"
        src="https://static.igem.wiki/teams/5058/imgs/fundo-engajamento-certo.png"
        alt="banner education"
      /> */}
      <img
        className="w-full min-h-full object-cover"
        src="https://static.igem.wiki/teams/5058/dados-education.svg"
        alt="banner education"
      />

      <section className="px-6 py-8">
        <h2>{t(`${educationContent}.introduction.title`)}</h2>
        <p>{t(`${educationContent}.introduction.text`)}</p>
        <p>{t(`${educationContent}.introduction.text2`)}</p>
      </section>

      <section className="px-6 py-8">
        <h2>{t(`${educationContent}.activities.title`)}</h2>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.activities.categories.functional.title`)}
          </h3>
          <p>
            {t(
              `${educationContent}.activities.categories.functional.description`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-50 object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/dnafuncional-exemplos.png"
              alt="banner education"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.activities.categories.bioartist.title`)}
          </h3>
          <p>
            {t(
              `${educationContent}.activities.categories.bioartist.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.activities.categories.bioartist.description2`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/educational-desenho.svg"
              alt="bannner engineering"
            />
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/educational-desenho2.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.activities.categories.agarart.title`)}
          </h3>
          <p>
            {t(`${educationContent}.activities.categories.agarart.description`)}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/educational-agararte.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.activities.categories.biosynStudio.title`)}
          </h3>
          <p>
            {t(
              `${educationContent}.activities.categories.biosynStudio.description`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/atividadebiosyn-2.png"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.activities.categories.origami.title`)}
          </h3>
          <p>
            {t(`${educationContent}.activities.categories.origami.description`)}
          </p>
          <p>
            {t(
              `${educationContent}.activities.categories.origami.description2`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/educational-dnaorigami.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.activities.categories.balloon.title`)}
          </h3>
          <p>
            {t(`${educationContent}.activities.categories.balloon.description`)}
          </p>
          <p>
            {t(
              `${educationContent}.activities.categories.balloon.description2`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.activities.categories.balloon.description3`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.activities.categories.balloon.description4`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.activities.categories.balloon.description5`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/educacional-fermenta-opratica2.svg"
              alt="bannner engineering"
            />
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/educacional-fermenta-opratica.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
      </section>

      <section className="px-6 py-8">
        <h2>{t(`${educationContent}.events.title`)}</h2>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.november.title`)}
          </h3>
          <h4>
            {t(
              `${educationContent}.events.categories.november.schoolVisitation.title`
            )}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.november.schoolVisitation.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.november.schoolVisitation.description2`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.november.schoolVisitation.description3`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/eventos-labfundao.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.decemberb.title`)}
          </h3>
          <h4>
            {t(
              `${educationContent}.events.categories.decemberb.biosciences.title`
            )}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.decemberb.biosciences.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.decemberb.biosciences.description2`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.decemberb.biosciences.description3`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-palestra.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.decemberbr.title`)}
          </h3>
          <h4>
            {t(
              `${educationContent}.events.categories.decemberbr.bionarua.title`
            )}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.decemberbr.bionarua.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.decemberbr.bionarua.description2`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.decemberbr.bionarua.description3`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-bionarua.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.may.title`)}
          </h3>
          <h4>{t(`${educationContent}.events.categories.may.sbbq.title`)}</h4>
          <p>
            {t(`${educationContent}.events.categories.may.sbbq.description`)}
          </p>
          <p>
            {t(`${educationContent}.events.categories.may.sbbq.description2`)}
          </p>
          <p>
            {t(`${educationContent}.events.categories.may.sbbq.description3`)}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-sbbq.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.june.title`)}
          </h3>
          <h4>
            {t(`${educationContent}.events.categories.june.lifescience.title`)}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.june.lifescience.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.june.lifescience.description2`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.june.lifescience.description3`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-cienciaviva.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.julyst.title`)}
          </h3>
          <h4>
            {t(
              `${educationContent}.events.categories.julyst.santaTerezinha.title`
            )}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.julyst.santaTerezinha.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.julyst.santaTerezinha.description2`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.julyst.santaTerezinha.description3`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-santaterezinha.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.julyc.title`)}
          </h3>
          <h4>
            {t(
              `${educationContent}.events.categories.julyc.collaboration.title`
            )}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.julyc.collaboration.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.julyc.collaboration.description2`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-logoolimpiada.svg"
              alt="bannner engineering"
            />
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-logosynbio.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.august.title`)}
          </h3>
          <h4>
            {t(
              `${educationContent}.events.categories.august.monteiroLobato.title`
            )}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.august.monteiroLobato.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.august.monteiroLobato.description2`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.august.monteiroLobato.description3`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/evento-colegmonterolobato.png"
              alt="bannner engineering"
            />
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
            {t(`${educationContent}.events.categories.september.title`)}
          </h3>
          <h4>
            {t(
              `${educationContent}.events.categories.september.presentation.title`
            )}
          </h4>
          <p>
            {t(
              `${educationContent}.events.categories.september.presentation.description`
            )}
          </p>
          <p>
            {t(
              `${educationContent}.events.categories.september.presentation.description2`
            )}
          </p>
          <p className="text-center">
            <img
              className="inline-block w-30 min-h-full object-cover"
              src="https://static.igem.wiki/teams/5058/imgs/eventos-plasmideos.svg"
              alt="bannner engineering"
            />
          </p>
        </article>
      </section>

      <section className="px-6 py-8">
        <h2>{t(`${educationContent}.socialMedia.title`)}</h2>
        <p>{t(`${educationContent}.socialMedia.description`)}</p>
        <p>{t(`${educationContent}.socialMedia.description2`)}</p>
        <p>{t(`${educationContent}.socialMedia.description3`)}</p>
        <p>{t(`${educationContent}.socialMedia.description4`)}</p>
      </section>
    </main>
  );
};
export default Page;
